import React from "react";
import Image from "next/image";
import FacebookIcon from "components/Icons/FacebookIcon";
import InstagramIcon from "components/Icons/InstagramIcon";
import LinkedinIcon from "components/Icons/LinkedinIcon";
import TwitterIcon from "components/Icons/TwitterIcon";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import getSocialFromUrl from "lib/getSocialFromUrl";
import classNames from "lib/classNames";

export default function NodeTeamMemberTeaser({ node }) {
  const components = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    linkedin: LinkedinIcon,
    twitter: TwitterIcon,
    other: ExternalLinkIcon,
  };

  return (
    <article className="flex flex-col bg-primary text-white rounded-lg overflow-hidden">
      <div className="order-1 px-12 py-8">
        <div className="font-important font-medium text-xl">{node.title}</div>
        {node.field_type && (
          <div className="font-important font-medium text-sm uppercase mt-1">
            {node.field_type.name}
          </div>
        )}
        {node.field_links && (
          <ul className="flex items-center gap-4 mt-4">
            {node.field_links.map((link) => {
              const social = getSocialFromUrl(link.uri);
              const IconComponent = components[social];

              return (
                <li>
                  <a
                    href={link.uri}
                    className="flex items-center gap-2 p-2 bg-white text-primary rounded-full hover:bg-primary-dark hover:text-white transition-colors"
                    target="blank"
                    rel="noreferrer"
                  >
                    <IconComponent className="w-5 h-5" />
                    <span
                      className={classNames(
                        "font-important font-medium text-sm uppercase",
                        social !== "other" && "sr-only"
                      )}
                    >
                      {link.title}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div className="order-0">
        <div className="aspect-w-15 aspect-h-11">
          <Image
            src={node.field_image.image_style_uri.portrait}
            {...node.field_image.resourceIdObjMeta}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            quality={100}
          />
        </div>
      </div>
    </article>
  );
}
